import { bundleSystem } from '@/data/systems'
import { RobotSystem } from '@/interfaces'
import { resetPassword } from './resetPassword'

export const createBundleSystem = function () {
  return async (system: RobotSystem, panelSerial: string, controlSerial: string) => {
    try {
      await bundleSystem(
        system,
        panelSerial,
        '361e158d-f913-49ce-8cf4-fc22af40b8a3',
        controlSerial,
        '25487055-0cd6-4d57-935b-0228f0369f72',
      );
      return resetPassword(system.id);
    } catch (error) {
      console.error("Bundling failed:", error);
      throw error;
    }
  };
};
